module.exports = __webpack_public_path__ + "static/assets/89b0a98b82e2fcad7e4563b348a1caf7.png";